(()=>{
  const init=(root)=>{
    root.querySelectorAll('[data-maison-hotspot]').forEach(btn=>{
      if(btn.dataset.bound==='1') return; btn.dataset.bound='1';
      btn.addEventListener('click',e=>{
        e.preventDefault();e.stopPropagation();
        const target=root.querySelector(`#${CSS.escape(btn.dataset.maisonHotspot)}`);
        const open=!target?.classList.contains('is-open');
        root.querySelectorAll('.maison-lookbook__product.is-open').forEach(el=>el.classList.remove('is-open'));
        root.querySelectorAll('[data-maison-hotspot]').forEach(el=>el.setAttribute('aria-expanded','false'));
        if(open&&target){target.classList.add('is-open');btn.setAttribute('aria-expanded','true')}
      });
    });
  };
  document.querySelectorAll('[data-maison-lookbook]').forEach(init);
  document.addEventListener('click',e=>{if(!e.target.closest('.maison-lookbook__product')&&!e.target.closest('[data-maison-hotspot]'))document.querySelectorAll('.maison-lookbook__product.is-open').forEach(el=>el.classList.remove('is-open'))});
  document.addEventListener('shopify:section:load',e=>{const root=e.target.querySelector?.('[data-maison-lookbook]');if(root)init(root)});
})();
/* =========================================================
   Mobile Lookbook — Auto close product card on slide scroll
   ========================================================= */

(() => {
  const mobileQuery = window.matchMedia('(max-width: 820px)');

  function closeOpenProduct(stage) {
    if (!mobileQuery.matches) return;

    const lookbook = stage.closest('.maison-lookbook');
    if (!lookbook) return;

    const openProducts = lookbook.querySelectorAll(
      '.maison-lookbook__product.is-open'
    );

    if (!openProducts.length) return;

    openProducts.forEach((product) => {
      product.classList.remove('is-open');
    });

    /* Reset any accessibility state on hotspot buttons */
    lookbook
      .querySelectorAll('[aria-expanded="true"]')
      .forEach((button) => {
        button.setAttribute('aria-expanded', 'false');
      });
  }

  document
    .querySelectorAll('.maison-lookbook__stage')
    .forEach((stage) => {
      let ticking = false;

      stage.addEventListener(
        'scroll',
        () => {
          if (ticking) return;

          ticking = true;

          requestAnimationFrame(() => {
            closeOpenProduct(stage);
            ticking = false;
          });
        },
        { passive: true }
      );
    });
})();
